module.exports = __webpack_public_path__ + "9e12d6053ae1c539d9be9d6fa86d33a7.otf";